import React from 'react';
import MainDataProvider from './main/MainDataProvider';
import AuthDataProvider from './auth/AuthDataProvider';
import RoutingDataProvider from './routing/RoutingDataProvider';
import SupportLoginDataProvider from './supportLogin/SupportLoginDataProvider';
import ResetPasswordDataProvider from './resetPassword/ResetPasswordDataProvider';
import SsoDataProvider from './sso/SsoDataProvider';
import { CssBaseline } from '@mui/material';
import C42Theme from '@c42/material-ui-theme';

const AppProviders: React.FC<React.PropsWithChildren<Record<never, any>>> = ({ children }) => (
  <C42Theme>
    <CssBaseline>
      <RoutingDataProvider>
        <AuthDataProvider>
          <MainDataProvider>
            <SsoDataProvider>
              <ResetPasswordDataProvider>
                <SupportLoginDataProvider>{children}</SupportLoginDataProvider>
              </ResetPasswordDataProvider>
            </SsoDataProvider>
          </MainDataProvider>
        </AuthDataProvider>
      </RoutingDataProvider>
    </CssBaseline>
  </C42Theme>
);

export default AppProviders;
